/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="97.33"
        height="95.54"
        viewBox="0 0 97.33 95.54"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M60.23 48.5h6v-5h-6Zm6.15 20h3.22v3.42H57.7v-3.47h3.22V55.52H57.7V52h8.68Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M89.23 33.42H38.06a8.18 8.18 0 0 0-8.15 8.15v32.5a8.12 8.12 0 0 0 8.14 7.9h35.57l13.14 13.24.09.09a1.26 1.26 0 0 0 2-1V82h.32a8.19 8.19 0 0 0 8.16-8.16V41.57a8.17 8.17 0 0 0-8.1-8.15Zm-51.17 2.5h51.17a5.67 5.67 0 0 1 5.66 5.65v32.24a5.69 5.69 0 0 1-5.66 5.66h-1.74a1.26 1.26 0 0 0-1.12 1.25v10.63L75 79.89a1.22 1.22 0 0 0-.89-.37h-36a5.61 5.61 0 0 1-5.65-5.57V41.57a5.68 5.68 0 0 1 5.6-5.65Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M57.01 0a7.91 7.91 0 0 1 7.89 7.64v27h-2.5V7.89a5.41 5.41 0 0 0-5.17-5.39H7.86a5.42 5.42 0 0 0-5.39 5.17v31.22a5.44 5.44 0 0 0 5.17 5.39h1.73a1.26 1.26 0 0 1 1.25 1.12v10.19l10.85-10.94a1.18 1.18 0 0 1 .74-.36h9.08v2.5h-8.4L10.26 59.51a1.26 1.26 0 0 1-1.77 0 1.32 1.32 0 0 1-.36-.76v-12h-.27a7.92 7.92 0 0 1-7.89-7.64V7.89A7.91 7.91 0 0 1 7.6 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M20.42 19.75a3.65 3.65 0 0 1 0 7.29 3.6 3.6 0 0 1-3.65-3.51v-.18a3.63 3.63 0 0 1 3.62-3.64M28.8 23.35a3.65 3.65 0 1 0 3.69-3.64 3.66 3.66 0 0 0-3.69 3.64M40.86 23.35a3.65 3.65 0 1 0 3.66-3.64 3.66 3.66 0 0 0-3.66 3.64"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoInformationalWordBubblesIcon';

export default Icon;
